<template>
  <div>
    <PsTabulator
      :ref="tabulatorRef"
      v-model="data"
      :data="data"
      :options="fullOptions"
      
    />
    <slot></slot>
  </div>
</template>

<script>
import PsTabulator from "./ps-tabulator";
import PsTooltip from "./ps-tooltip";
import Vuetify from "@/plugins/vuetify";
export default {
  name: "PsTable",
  components: {
    PsTabulator,
  },
  provide: function() {
    return {
      getTabulatorReference: this.$props.tabulatorRef,
    };
  },
  props: {
    tabulatorRef: {
      type: String,
      required: false,
      default: "tabulator",
    },
    data: {
      type: Array,
      required: false,
      default: () => [],
    },
    options: {
      type: Object,
      required: true,
    },
    filterString: {
      type: String,
      default: "",
      required: false,
    },
    componentGuid: {
      type: String,
      default: "",
      required: false,
    },
    initTableLayout: {
      type: Function,
      default: () => {},
      required: false,
    },
    filterExclude: {
      type: Array,
      default: function() {
        return [];
      },
      required: false,
    },
    resizeCallback:null
  },
  data() {
    return {
      columns: [],
      tooltips: [],
      tableRef: ""
    };
  },
  computed: {
    fullOptions() {     
      this.options.columnResized=this.resizeCallback;

      if (typeof (this.options.columnHeaderVertAlign) === "undefined") {
        this.options.columnHeaderVertAlign = "bottom";
      }

      if (typeof (this.options.addRowPos) === "undefined") {
        this.options.addRowPos = "bottom";
      }

      if (typeof (this.options.printAsHtml) === "undefined") {
        this.options.printAsHtml = true;
      }
      
      if (typeof (this.options.printStyled) === "undefined") {
        this.options.printAsHtml = true;
      }

      if (typeof (this.options.printCopyStyle) === "undefined") {
        this.options.printAsHtml = true;
      }

      if (typeof (this.options.tabEndNewRow) === "undefined") {
        this.options.tabEndNewRow = true;
      }

      if (typeof (this.options.persistenceID) === "undefined") {
        this.options.persistenceID = "tabulator";
      }

      if (typeof (this.options.cellClick) === "undefined") {
        this.options.cellClick = (e, cell) => {};
      }

      if (typeof (this.options.cellEdited) === "undefined") {
        this.options.cellEdited = (cell) => {
          if (
            cell.getElement().innerHTML.indexOf('<input type="checkbox"') > -1
          ) {
            cell.edit();
          }
          cell._cell.edited = true;
          var editedRow = cell.getRow();
          editedRow._row.data.edited = true;
          this.setRowCondition(editedRow);
        };
      }

      if (typeof (this.options.resizableColumns) === "undefined") {
        this.options.resizableColumns = true;
      }

      if (typeof (this.options.movableColumns) === "undefined") {
        this.options.movableColumns = true;
      }

      if (typeof (this.options.height) === "undefined") {
        this.options.height =
          Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          ) -
          200 +
          "px";
      }

      if (typeof (this.options.renderComplete) === "undefined") {
        this.options.renderComplete = () => {
          this.attachToolTips(this.tooltips);
          const tabulatorInstance = this.$refs[this.$props.tabulatorRef].getInstance();
          if (typeof(tabulatorInstance.getPage) == 'function'){
            var currentPage = tabulatorInstance.getPage();
            var maxPages = tabulatorInstance.getPageMax();
            
              if($(this.$el).find('#changePage').length == 0){
                $(this.$el).find(".tabulator-pages").html( '<select id="changePage"></select> <div class="currentPage">of ' + maxPages + '</div><span class="icon-play-24 pointleft" \>' );  
                var i;
                for( i=1; i<=tabulatorInstance.getPageMax(); i++ ){
                  $(this.$el).find('#changePage').append('<option value="'+i+'">'+i+'</option>');
                }
                $(this.$el).find('#changePage').val(currentPage);
                $('#changePage').on('change', function(e){
                  tabulatorInstance.setPage(parseInt($(this).val()));
               });
              }
              
          }

           if(typeof(tabulatorInstance.redraw) === "function") {         
                if($('.v-overlay__scrim').length === 0) {
                    var w = tabulatorInstance.tableWidth;
                    $("#w-box").width(w);
                    tabulatorInstance.redraw();                
                }
            }
        }
      }


      if (typeof (this.options.locale) === "undefined") {
        this.options.locale = 'pagination';
      }

      var  langs =  {
          pagination: {
            pagination: {
              first: "<span class='icon-last-page pointleft no-print'></span>",
              first_title: "First Page", 
              last: "<span class='icon-last-page no-print'></span>",
              last_title: "Last Page",
              prev: "<span class='icon-play-24 no-print pointleft'></span>",
              prev_title: "Previous Page",
              next: "<span class='icon-play-24 no-print'></span>",
              next_title: "Next Page"
            }
          }
        };

      this.options.langs = $.extend(langs, this.options.langs);
     
      if (typeof (this.options.paginationSize) === "undefined") {
        this.options.paginationSize = 3;
      }

      if (typeof (this.options.paginationButtonCount) === "undefined") {
        this.options.paginationButtonCount = 1;
      }

     this.options.keybindings = $.extend(this.options.keybindings, {scrollToStart: 'ctrl + 36', scrollToEnd: 'ctrl + 35'});

      if (typeof(this.options.printRowRange ) === "undefined") {
        this.options.printRowRange = 'all';
      }

      return this.options;
    }
  },
  mounted() {
    this.tableRef = "tabulator";
    this.$emit("init-table-layout");
  },
  watch: {
    filterString: function(newFilterString) {
      const tabulatorInstance = this.$refs[
        this.$props.tabulatorRef
      ].getInstance();

      if (newFilterString.length === 0) {
        tabulatorInstance.clearFilter();
        return;
      }

      var filters = [];
      var columns = tabulatorInstance.getColumns();
      var that = this;

      columns.forEach(function(column) {
        if (!that.filterExclude.includes(column.getField())) {
          filters.push({
            field: column.getField(),
            type: "like",
            value: newFilterString,
          });
        }
      });

      tabulatorInstance.setFilter([filters]);
      return "";
    },
  },
  destroyed() {
   // window.Bus.$off("TooltipAdded");
    //window.Bus.$off("NewColumnAdded");
  },
  created() {
     //   window.Bus.$off("TooltipAdded");
    //window.Bus.$off("NewColumnAdded");

    //if(window.Bus._events["TooltipAdded"] !== null) {
    //  window.Bus.$off("TooltipAdded");
   // }

    window.Bus.$on("TooltipAdded", (tooltip) => {
      this.tooltips.push(tooltip);
    });

    window.Bus.$on("NewColumnAdded", (column) => {
      if (this.$refs[column.tableRef] === undefined) {
        return;
      }

      var table = this.$refs[column.tableRef].getInstance();
      table.options.columns.push(column.props);
      table.addColumn(column.props);
    });
  },
  methods: {
    setRowCondition(row) {
      var currentRowPosition = row.getPosition();
      if (this.data[currentRowPosition] !== undefined) {
        this.data[currentRowPosition].changed = true;
      }      
    },    
    getPendingChanges() {
      var tableInstance = this.$refs[this.$props.tabulatorRef].getInstance();

      var edited = tableInstance.rowManager.rows.filter(
        (row) => row.data.edited == true
      );
      var deleted = tableInstance.rowManager.rows.filter(
        (row) => row.data.markedForDeletion == true
      );
      return {
        toEdit: edited,
        toDelete: deleted,
      };
    },
    attachToolTips(toolTips) {
      
      toolTips.forEach((t) => {
        var Profile = Vue.extend(PsTooltip);
        var instance = new Profile({
          propsData: {
            text: t.text,
            bottom: true,
          },
          vuetify: Vuetify,
        });
        var element = document.getElementById(t.id);
        if (element !== undefined && element !== null) {
          instance.$mount("#" + t.id);
        }
      });
      window.Bus.$emit("TableLoaded", this.$refs[this.$props.tabulatorRef].getInstance());
    },
  },
};
</script>
<style lang="scss">
.p4-report {
    @import '../styles/ps-report-table.scss';
}

.p4-report-control {
    @import '../styles/ps-table-control.scss';
}
</style>